import { FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";

import config from "../../Config/clientConfig.json";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import PointsRedemption from "../Loyalty/components/RadeemPoints";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
interface StatusProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  statusId?: string;
  paymentId: string;
  customerId: string;
  customerName: string;
  orderTotal: number;
  availablePoints: number;
  redeemPoints: number;
  setRedeemPoints: (points: number) => void;
  setApplied: (applied: boolean) => void;
  // setProceed: (proceed: boolean) => void;
}

export const UpdatePayment: React.FC<StatusProps> = ({
  control,
  errors,
  register,
  id,
  reset,
  statusId,
  paymentId,
  customerId,
  customerName,
  orderTotal,
  availablePoints,
  redeemPoints,
  setRedeemPoints
}) => {
  useEffect(() => {
    reset();
  }, [id, reset]);

  return (
    <Grid>
      <Grid className="modal-input" container spacing={2}>
        <Grid item xs={12} sm={12}>
          <WSSelectField
            options={config.paymentTypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("paymentMethod")}
            id="paymentMethod"
            control={control}
            label="Payment Method"
            name="paymentMethod"
          />
        </Grid>
        <Grid item sm={12}>
          <WSTextField
            id="amountPaid"
            label="Amount (₹)"
            name="amountPaid"
            control={control}
            rules={{ required: "please enter the amount" }}
          />
          <WSHiddenField
            control={control}
            name="paymentId"
            defaultValue={paymentId}
          />
          <WSSCheckBoxField id="applyPoints" label="Proceed with Points" name="applyPoints" control={control} rules={{required:false}} disabled={availablePoints <= 0}/>
          <PointsRedemption
            customerId={customerId}
            customerName={customerName}
            availablePoints={availablePoints}
            redeemPoints={redeemPoints}
            setRedeemPoints={setRedeemPoints}
            // maxRedeemablePoints={availablePoints}
            // valuePerPoint={0.5}
            orderTotal={orderTotal}
            // onConfirm={handleConfirm}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
